import React, {PropsWithChildren} from "react";

interface Props {
    onClick: () => any
}

export const Button = (props: PropsWithChildren<Props>) =>
    <button className="button" onClick={() => props.onClick()}>
        {props.children}
    </button>